import {
  AutoComplete,
  Input,
  Form,
  Select,
  Spin,
  Button,
  DatePicker,
  TreeSelect,
  TreeSelectProps,
} from "antd";

import { ShopOutlined } from "@ant-design/icons";
import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  SetStateAction,
} from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import usePrevious from "../../hooks/PreviousState";
import {
  getParamValue,
  OrderTypeArray,
  checkStatesAndPushToHistory,
  getUpdatedUrl,
  jcTypeArray,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBiking } from "@fortawesome/free-solid-svg-icons";
import { DefaultOptionType } from "antd/lib/select";
import { responseNotification } from "../../utils/notify";
import { debounce } from "lodash";
const { Option } = Select;
const { RangePicker } = DatePicker;

const OrderList = ({
  gethubId,
  inShop = false,
  inHub = false,
  activeSearch = true,
}: {
  gethubId?: string;
  inShop?: boolean;
  inHub?: boolean;
  activeSearch?: boolean;
}) => {
  const route = useParams();
  const history = useHistory();
  const router = useLocation();
  const [status, setStatus] = useState(getParamValue(router.search, "status"));
  const previousStatus = usePrevious(status);
  const [deliveryMan, setDeliveryMan] = useState<any>();
  const [type, setType] = useState("JC_MART");
  const [mobileNumber, setMobileNumber] = useState(
    getParamValue(router.search, "mobileNumber")
  );
  const [pmethodId, setPmethodId] = useState("");
  const previousMobileNumber = usePrevious(mobileNumber);
  const [hubId, setHubId] = useState(getParamValue(router.search, "hubId"));
  const previousHubId = usePrevious(hubId);
  const [shopId, setShopId] = useState(getParamValue(router.search, "shopId"));
  const previousShopId = usePrevious(shopId);
  const [minimumOrderAmount, setMinimumOrderAmount] = useState(0.0);
  const [productName, setProductName] = useState("");
  const [categoryId, setCategoryId] = useState<any>();
  const [paymentMethod, setPaymentMethod] = useState<any>({
    loading: false,
    list: [],
  });
  const [range, setRange] = useState({
    from: getParamValue(router.search, "from")
      ? getParamValue(router.search, "from")
      : null,
    to: getParamValue(router.search, "to")
      ? getParamValue(router.search, "to")
      : null,
  });
  const previousRangeFrom = usePrevious(range.from);
  const previousRangeTo = usePrevious(range.to);

  const [limit, setLimit] = useState(16);
  const [visible, setVisible] = useState(undefined);
  const [baseOrderId, setBaseOrderId] = useState(
    getParamValue(router.search, "baseOrderId")
  );
  const previousBaseOrderId = usePrevious(baseOrderId);
  const [orderId, setOrderId] = useState(
    getParamValue(router.search, "orderId")
  );
  const previousOrderId = usePrevious(orderId);
  const [selectedOrder, setSelectedOrder] = useState(undefined);
  const [selectedOrderForEdit, setSelectedOrderForEdit] = useState(undefined);

  const [orderData, setOrderData] = useState({
    loading: false,
    data: null,
  });
  const [orderOptions, setOrderOptions] = useState({
    loading: false,
    list: [],
  });
  const [usersOptions, setUsersOptions] = useState({
    loading: false,
    list: null,
  });

  const [hubOptions, setHubOptions] = useState({
    loading: false,
    list: [],
  });
  const [productOptions, setProductOptions] = useState({
    loading: false,
    list: [],
  });
  const [shopOptions, setShopOptions] = useState({
    loading: false,
    list: [],
  });
  const [treeData, setTreeData] = useState<Omit<DefaultOptionType, "label">[]>(
    []
  );
  const fetchRef = useRef(null);

  const [form] = Form.useForm();
  const page = getParamValue(router.search, "page") || 0;

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };

  const reseAllFieldData = () => {
    setBaseOrderId("");
    setOrderId("");
    setMobileNumber("");
    setStatus("");
    setDeliveryMan("");
    setType("");
    setHubId("");
    setShopId("");
    setCategoryId("");
    setProductName("");
    setPaymentMethod("");
    setMinimumOrderAmount(0.0);
    setCategoryId("");
    form.resetFields();
    setRange({
      from: null,
      to: null,
    });

    history.replace(router.pathname);
    window.location.reload();
  };

  const fatchPaymentMethod = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_PAY_API}/payment-method?type=JC_COMMERCE`,
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-type": "application/json",
        },
      }
    );
    const response = await data.json();

    setPaymentMethod({
      loading: false,
      list: response?.methods?.map((method: { name: any }) => ({
        value: method.name,
        label: method.name,
      })),
    });
  };

  useEffect(() => {
    fatchPaymentMethod();
  }, []);

  const getAllOrders = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberOrderList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberOrderList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [
          previousBaseOrderId,
          previousOrderId,
          previousMobileNumber,
          previousHubId,
          previousShopId,
          previousStatus,
          previousRangeFrom,
          previousRangeTo,
        ],
        [
          baseOrderId,
          orderId,
          mobileNumber,
          hubId,
          shopId,
          status,
          range.from,
          range.to,
        ],
        [
          "baseOrderId",
          "orderId",
          "mobileNumber",
          "hubId",
          "shopId",
          "status",
          "from",
          "to",
        ],
        history
      );
    }

    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setOrderData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    if (inShop) {
      axios
        .get(
          `${encodedUri}/admin/order/by-shop?` +
            (baseOrderId ? `orderIdOrBaseOrderId=${baseOrderId}` : ``) +
            // (orderId ? `orderId=${orderId}` : ``) +
            // (baseOrderId ? `baseOrderId=${baseOrderId}` : ``) +
            (mobileNumber ? `&mobileNumber=${mobileNumber}` : ``) +
            `&shopId=${(route as any)?.shopId || ``}` +
            (hubId ? `&hubId=${hubId}` : ``) +
            (type ? `&type=${type}` : ``) +
            (status ? `&status=${status}` : ``) +
            (from ? `&from=${from}` : ``) +
            (to ? `&to=${to}` : ``) +
            (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
            (limit ? `&limit=${limit}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setOrderData({ loading: false, data: res.data });
        })
        .catch((err) => {
          setOrderData({ loading: false, data: [] });
          console.error("Category: Error", err);
        });
    } else if (inHub) {
      axios
        .get(
          `${encodedUri}/admin/order/v2?` +
            (orderId ? `&orderIdOrBaseOrderId=${orderId}` : ``) +
            (mobileNumber ? `&mobileNumber=${mobileNumber}` : ``) +
            (gethubId ? `&hubId=${gethubId}` : ``) +
            (shopId ? `&shopId=${shopId}` : ``) +
            (type ? `&type=${type}` : ``) +
            (status ? `&status=${status}` : ``) +
            (categoryId ? `&categoryName=${categoryId}` : ``) +
            (productName ? `&productName=${productName}` : ``) +
            (pmethodId ? `&paymentMethod=${pmethodId}` : ``) +
            (minimumOrderAmount
              ? `&minimumOrderAmount=${minimumOrderAmount}`
              : ``) +
            (from ? `&from=${from}` : ``) +
            (to ? `&to=${to}` : ``) +
            (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
            (limit ? `&limit=${limit}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setOrderData({ loading: false, data: res.data });
        })
        .catch((err) => {
          setOrderData({ loading: false, data: [] });
          console.error("Category: Error", err);
        });
    } else {
      axios
        .get(
          `${encodedUri}/admin/order/v2?type=${type}` +
            (orderId ? `&orderIdOrBaseOrderId=${orderId}` : ``) +
            (mobileNumber ? `&mobileNumber=${mobileNumber}` : ``) +
            (hubId ? `&hubId=${hubId}` : ``) +
            (shopId ? `&shopId=${shopId}` : ``) +
            (status ? `&status=${status}` : ``) +
            (categoryId ? `&categoryName=${categoryId}` : ``) +
            (productName ? `&productName=${productName}` : ``) +
            (pmethodId ? `&paymentMethod=${pmethodId}` : ``) +
            (minimumOrderAmount
              ? `&minimumOrderAmount=${minimumOrderAmount}`
              : ``) +
            (from ? `&from=${from}` : ``) +
            (to ? `&to=${to}` : ``) +
            (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
            (limit ? `&limit=${limit}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setOrderData({ loading: false, data: res.data });
        })
        .catch((err) => {
          setOrderData({ loading: false, data: [] });
          console.error("Category: Error", err);
        });
    }
  }, [
    inShop,
    inHub,
    gethubId,
    mobileNumber,
    orderId,
    hubId,
    shopId,
    route,
    page,
    type,
    status,
    categoryId,
    productName,
    pmethodId,
    minimumOrderAmount,
    limit,
    range,
  ]);

  useEffect(() => {
    getAllOrders();
  }, [getAllOrders]);

  const genTreeNode = (parentId: number, category: any) => {
    return {
      ...category,
      id: category?.id,
      pId: parentId,
      value: category?.title,
      title: category?.title,
      isLeaf: false,
    };
  };
  const getParentCategory = useCallback(async (val: string) => {
    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/parent-by-type?type=${type}&page=0&limit=50` +
        (val ? `&key=${val}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );
    setTreeData(
      res.data?.categories?.map(
        (category: Omit<DefaultOptionType, "label">) => ({
          ...category,
          id: category?.id,
          pId: 0,
          title: category?.title,
          value: category?.title,
          isLeaf: false,
        })
      )
    );
  }, []);

  const onLoadData: TreeSelectProps["loadData"] = ({ id }) => {
    return new Promise((resolve) => {
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/admin/category/child-category-by-parent?categoryId=${id}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            // ****************************
            setTimeout(() => {
              setTreeData(
                treeData?.concat(
                  data?.data?.categories?.map(
                    (category: Omit<DefaultOptionType, "label">) =>
                      genTreeNode(id, category)
                  )
                )
              );
              resolve(undefined);
            }, 300);
            // ****************************
          } else {
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  const onChange = (newValue: string) => {
    setCategoryId(newValue);
  };

  const filteredCategory = treeData.find((category) => {
    return category?.id === categoryId;
  });

  const getOrderOptions = useCallback(
    async (getOrderId: any) => {
      setOrderOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
      return axios
        .get(
          `${encodedUri}/admin/order/v2?page=${page || 0}` +
            (getOrderId ? `&orderIdOrBaseOrderId=${getOrderId}` : ``) +
            (type ? `&type=${type}` : ``) +
            (status ? `&status=${status}` : ``) +
            (limit ? `&limit=${limit}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setOrderOptions({
            loading: false,
            list: res.data?.orders?.map(
              (order: { baseOrderId: string; orderId: string }) => ({
                label: `${order?.baseOrderId} || ${order?.orderId}`,
                value: order?.baseOrderId,
              })
            ),
          });
        })
        .catch((err) => {
          setOrderOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [limit, page, status, type]
  );
  const getProductOptions = useCallback(async (key: any) => {
    setProductOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    return axios
      .get(
        `${encodedUri}/admin/product/search?type=${type}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setProductOptions({
          loading: false,
          list: res.data?.keys?.map((product: { name: any }) => ({
            label: product.name,
            value: product.name,
          })),
        });
      })
      .catch((err) => {
        setProductOptions({ loading: false, list: [] });
        console.error("Products: Error", err);
      });
  }, []);
  const getUsersOptions = useCallback(
    async (mobileNumber) => {
      setUsersOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
      axios
        .get(
          `${encodedUri}/admin/user?` +
            `page=${0}` +
            `&limit=${20}` +
            (status ? `&status=${status}` : ``) +
            (mobileNumber
              ? `&mobileNumber=%2B88${mobileNumber?.replace("+88", "")}`
              : ``),
          // (mobileNumber ? `&mobileNumber=%2B88${mobileNumber}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setUsersOptions({
            loading: false,
            list: res.data?.users?.map((user) => ({
              label: user.fullName,
              value: user.mobileNumber.replace("+88", ""),
            })),
          });
        })
        .catch((err) => {
          setUsersOptions({ loading: false, list: [] });
          console.error("Users: Error", err);
        });
    },
    [status]
  );

  const getHubOptions = useCallback(
    async (key) => {
      setHubOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/hub/search?page=0&limit=20` +
            (key ? `&name=${key}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setHubOptions({
            loading: false,
            list: res.data?.hub?.map((hub) => ({
              value: hub.id,
              label: hub.name,
            })),
          });
        })
        .catch((err) => {
          setHubOptions({ loading: false, list: [] });
          console.error("Hubs: Error", err);
        });
    },
    [type]
  );

  const getShopOptions = useCallback(
    async (key) => {
      setShopOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/shop/admin/search?page=0&limit=20` +
            (hubId ? `&hubId=${hubId}` : ``) +
            (gethubId ? `&hubId=${gethubId}` : ``) +
            (key ? `&key=${key}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setShopOptions({
            loading: false,
            list: res.data?.shops?.map((shop) => ({
              value: shop.id,
              label: shop.name,
            })),
          });
        })
        .catch((err) => {
          setShopOptions({ loading: false, list: [] });
          console.error("Shops: Error", err);
        });
    },
    [type, hubId, gethubId]
  );

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "order") getOrderOptions(value);
        if (field === "hub") getHubOptions(value);
        if (field === "product") getProductOptions(value);
        else if (field === "user") getUsersOptions(value);
        else if (field === "shop") getShopOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getHubOptions,
    getUsersOptions,
    getOrderOptions,
    getProductOptions,
    getShopOptions,
  ]);

  useEffect(() => {
    if (visible) {
      setSelectedOrder(undefined);
      setSelectedOrderForEdit(undefined);
    }
  }, [selectedOrder, selectedOrderForEdit, visible]);

  useEffect(() => {
    getHubOptions("");
    getShopOptions("");
    getOrderOptions("");
    getParentCategory("");
    getProductOptions("");
  }, [
    getHubOptions,
    getShopOptions,
    getOrderOptions,
    getParentCategory,
    getProductOptions,
  ]);

  useEffect(() => {
    if (hubId) {
      getShopOptions(``);
      setShopId(undefined);
      form.resetFields(["shop_search"]);
    }
  }, [form, getShopOptions, hubId]);

  const handleChangeStatus = (value: string) => {
    setStatus(value);
  };

  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(localStorage.getItem("rememberOrderList"));
    console.log("rememberOrderList: ", retrievedObject);
    if (retrievedObject.baseOrderId)
      setBaseOrderId(retrievedObject.baseOrderId);
    if (retrievedObject.orderId) setOrderId(retrievedObject.orderId);
    if (retrievedObject.mobileNumber)
      setMobileNumber(retrievedObject.mobileNumber);
    if (retrievedObject.hubId) setHubId(retrievedObject.hubId);
    if (retrievedObject.shopId) setShopId(retrievedObject.shopId);
    if (retrievedObject.status) setStatus(retrievedObject.status);
    if (retrievedObject.from && retrievedObject.to) {
      setRange({ from: retrievedObject.from, to: retrievedObject.to });
    }
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }

  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberOrderList",
      JSON.stringify({
        baseOrderId: baseOrderId,
        orderId: orderId,
        mobileNumber: mobileNumber,
        hubId: hubId,
        shopId: shopId,
        status: status,
        from: range.from,
        to: range.to,
        page: page,
      })
    );
  };

  return (
    <React.Fragment>
      {!inShop && !inHub && (
        <TopHeading
          total={orderData?.data?.totalElements}
          refetch={getAllOrders}
        />
      )}
      {activeSearch && (
        <>
          <section className={`search_area ${inShop || inHub ? `mb-0` : ``}`}>
            <Form form={form} className="search_form">
              <Form.Item initialValue={type}>
                <Select
                  placeholder="Type"
                  onChange={(val) => setType(val)}
                  value={type}
                >
                  {Object.values(jcTypeArray)?.map((type, i) => (
                    <Option value={type} key={i}>
                      {type?.replace("_", " ")}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="baseOrderIdSearch" initialValue={orderId}>
                <AutoComplete
                  backfill
                  allowClear
                  style={{ width: 250 }}
                  onSearch={(e) => handleSearch(e, "order")}
                  onSelect={(val: any) => {
                    setOrderId(val);
                  }}
                  options={orderOptions?.list}
                  defaultActiveFirstOption={false}
                  notFoundContent={
                    orderOptions?.loading ? <Spin size="small" /> : null
                  }
                  dropdownMatchSelectWidth={335}
                >
                  <Input.Search
                    size="large"
                    placeholder="Base Order or Order ID"
                    onSearch={(val) => {
                      setOrderId(val);
                    }}
                    enterButton
                  />
                </AutoComplete>
              </Form.Item>
              <Form.Item name="phone_search" initialValue={mobileNumber}>
                <AutoComplete
                  style={{ width: 250 }}
                  onSearch={(e) => handleSearch(e, "user")}
                  onSelect={(val) => setMobileNumber(val.toString())}
                  options={usersOptions?.list}
                  defaultActiveFirstOption={false}
                  notFoundContent={
                    usersOptions?.loading ? <Spin size="small" /> : null
                  }
                >
                  <Input.Search
                    size="large"
                    placeholder="Search by User Phone"
                    onSearch={(val) => setMobileNumber(val)}
                    enterButton
                    loading={usersOptions.loading}
                    maxLength={11}
                    type="number"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </AutoComplete>
              </Form.Item>

              {!inShop && (
                <>
                  {!inHub && (
                    <Form.Item name="hub_search" initialValue={hubId}>
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Hub"
                        optionFilterProp="children"
                        onChange={(val) => setHubId(val)}
                        onSearch={(e) => handleSearch(e, "hub")}
                        filterOption={() => {
                          return true;
                        }}
                        options={hubOptions?.list}
                      ></Select>
                    </Form.Item>
                  )}

                  <Form.Item name="shop_search" initialValue={shopId}>
                    <Select
                      allowClear
                      showSearch
                      placeholder="Filter by Shop"
                      optionFilterProp="children"
                      onChange={(val) => setShopId(val)}
                      onSearch={(e) => handleSearch(e, "shop")}
                      filterOption={() => {
                        return true;
                      }}
                      options={shopOptions?.list}
                    ></Select>
                  </Form.Item>
                </>
              )}

              <Form.Item name="status_search" initialValue={status}>
                <Select
                  showSearch
                  placeholder="Filter by Status"
                  onChange={handleChangeStatus}
                >
                  <Select.Option value="">ALL STATUS</Select.Option>
                  {Object.values(OrderTypeArray)?.map((type, i) => (
                    <Select.Option value={type} key={i}>
                      {type?.split("_").join(" ")}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="category_search">
                <TreeSelect
                  allowClear
                  treeDataSimpleMode
                  style={{ width: "100%" }}
                  value={categoryId}
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  placeholder="Filter by Category"
                  onChange={onChange}
                  loadData={onLoadData}
                  treeData={treeData}
                />
              </Form.Item>

              <Form.Item name="product_search">
                <AutoComplete
                  style={{ width: 300 }}
                  onSearch={(e) => handleSearch(e, "product")}
                  onSelect={(val: { toString: () => SetStateAction<string> }) =>
                    setProductName(val.toString())
                  }
                  options={productOptions?.list}
                  defaultActiveFirstOption={false}
                  notFoundContent={
                    productOptions?.loading ? <Spin size="small" /> : null
                  }
                >
                  <Input.Search
                    placeholder="Search by Product Name"
                    onSearch={(val) => setProductName(val)}
                    enterButton
                    loading={productOptions.loading}
                  />
                </AutoComplete>
              </Form.Item>
              <Form.Item name="payment_method" initialValue={pmethodId}>
                <Select.Option value="">Filter by Payment Method</Select.Option>
                <Select
                  showSearch
                  onChange={(val) => setPmethodId(val)}
                  placeholder="Filter by Payment Method"
                  options={paymentMethod?.list}
                ></Select>
              </Form.Item>
              <Form.Item
                name="payment_amount"
                initialValue={minimumOrderAmount}
              >
                <AutoComplete style={{ width: 250 }}>
                  <Input.Search
                    placeholder="Minimum Order Amount"
                    onSearch={(val) => setMinimumOrderAmount(parseFloat(val))}
                    enterButton
                    loading={usersOptions.loading}
                    maxLength={11}
                    min={1}
                    type="number"
                  />
                </AutoComplete>
              </Form.Item>

              <Form.Item name="range">
                <RangePicker
                  defaultValue={
                    range.from != null && range.to != null
                      ? [moment(range.from), moment(range.to)]
                      : null
                  }
                  onChange={(e, f) => {
                    console.log("momnet", moment.utc(f[0])?.toISOString());
                    setRange({ from: f?.[0], to: f?.[1] });
                  }}
                  showTime={{
                    hideDisabledOptions: true,
                    defaultValue: [
                      moment("00:00:00", "HH:mm:ss"),
                      moment("23:59:59", "HH:mm:ss"),
                    ],
                  }}
                  inputReadOnly
                  allowClear
                />
              </Form.Item>
            </Form>
            <div className="search_btn">
              <Button
                type="primary"
                size="large"
                danger
                onClick={reseAllFieldData}
              >
                Reset
              </Button>
            </div>
          </section>
        </>
      )}
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Order ID</span>
                  </div>
                  <div className="single-product-heading major">
                    <span>Date & Time</span>
                  </div>{" "}
                  {!inShop && (
                    <div className="single-product-heading major">
                      <span>Shop Name</span>
                    </div>
                  )}
                  <div className="single-product-heading">
                    <span>Method</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Total</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Delivery Man</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {orderData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {orderData?.data?.orders?.length ? (
                    orderData?.data?.orders?.map(
                      (order: any, index: number) => (
                        <React.Fragment key={index}>
                          <Link
                            onClick={saveCurrentStatesInLocalStorage}
                            to={
                              inShop
                                ? `/shops/${
                                    (route as any)?.shopId as string
                                  }/orders/${order?.orderId}/details`
                                : inHub
                                ? `/hubs/${gethubId}/orders/${order?.orderId}/details`
                                : `/orders/${order?.orderId}`
                            }
                          >
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <span className="name">
                                  {order?.baseOrderId} <br />
                                  {order?.orderId}
                                </span>
                              </div>

                              <div
                                className="single-product major"
                                style={{ display: "block" }}
                              >
                                <small
                                  className={`text-capitalize ${
                                    moment().diff(
                                      order?.createdAt,
                                      "minutes"
                                    ) >= 60
                                      ? "font-weight-bold text-danger"
                                      : "text-dark"
                                  }`}
                                >
                                  {moment(order?.createdAt).fromNow()}
                                </small>
                                <br />
                                <span className="name text-nowrap_">
                                  {moment(order?.createdAt).format("lll")}
                                </span>
                              </div>
                              {!inShop && (
                                <div className="single-product major">
                                  <span className="name">
                                    <ShopOutlined /> {order?.shop?.name}
                                  </span>
                                </div>
                              )}
                              <div className="single-product">
                                <span className="name text-uppercase text-nowrap">
                                  {order?.paymentMethod?.split("_").join(" ")}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  &#2547;{parseInt(order?.total)}
                                </span>
                              </div>
                              <div className="single-product">
                                {order?.deliveryMan?.name ? (
                                  <span className="name">
                                    {order?.deliveryMan?.name}
                                    <br />
                                    {order?.deliveryMan?.mobileNumber.split(
                                      "+88"
                                    )}
                                  </span>
                                ) : (
                                  <span className="radius-btn text-muted text-nowrap">
                                    <FontAwesomeIcon
                                      icon={faBiking}
                                      className="text-danger mr-2"
                                    />
                                    UNASSIGNED
                                  </span>
                                )}
                              </div>

                              <div className="single-product">
                                <span
                                  className={`radius-btn ${order?.status?.toLowerCase()}-btn text-nowrap`}
                                >
                                  {order?.status?.split("_").join(" ")}
                                </span>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Order" />
                  )}
                </div>
              </div>
            )}
          </div>

          <PaginationTwo
            {...orderData.data}
            limit={limit}
            page={orderData?.data?.currentPageNumber || 0}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderList;
